module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerName),
      expression: "customerName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Mobile),
      expression: "Mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Email),
      expression: "Email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "邮箱地址"
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Password),
      expression: "Password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "登录密码"
    },
    domProps: {
      "value": (_vm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    attrs: {
      "id": "password"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rePassword),
      expression: "rePassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.addEnterprise),
      expression: "addEnterprise",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "open-popup open-enterprise",
    attrs: {
      "data-popup": ".popup-enterprise",
      "type": "text",
      "placeholder": "单位名称",
      "id": "enterpriseName",
      "readonly": "",
      "unselectable": "on"
    },
    domProps: {
      "value": (_vm.addEnterprise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addEnterprise = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [(_vm.showSecondLevelEnterprise) ? _c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("二级单位")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondLevelEnterpriseNo),
      expression: "secondLevelEnterpriseNo"
    }],
    attrs: {
      "name": "fruit",
      "placeholder": "请选择二级单位"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.secondLevelEnterpriseNo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.secondLevelEnterpriseList), function(va) {
    return _c('option', {
      domProps: {
        "value": va.enterpriseNo
      }
    }, [_vm._v(_vm._s(va.enterpriseName))])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址(可选)")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.Address),
      expression: "Address",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.Address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Address = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("接收促销信息")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isReceivePromotion),
      expression: "isReceivePromotion"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isReceivePromotion) ? _vm._i(_vm.isReceivePromotion, null) > -1 : (_vm.isReceivePromotion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isReceivePromotion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isReceivePromotion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isReceivePromotion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isReceivePromotion = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "7.4rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("发送")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [(_vm.disableSubmit) ? _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]) : _c('span', {
    staticClass: "button button-big button-fill fill-grey"
  }, [_vm._v("提交")])])])])]), _vm._v(" "), _c('modal-register-agreement', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "update:show": function($event) {
        _vm.showModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba166d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyLogin/Register.vue
// module id = 1582
// module chunks = 8